export const TYPES = ['main', 'promo'];

export default {};
